import React from 'react';
import PropTypes from 'prop-types';
import 'react-activity-feed/dist/index.css';

import './styles/TimelinePage.scss';

export default class ClippPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = { isLoading: true };

    // Need to get the current Clipp ID from the URL
  }

  render() {
    const { darkMode } = this.props;

    return (
      <div className='user-feed'>
        <div className='mainPanel' ref='mainPanel' style={{ background: darkMode ? 'rgb(11, 19, 61)' : '' }}>
          <p>Clipp Page</p>
          <p>-- Clipp Details</p>
          <p>-- Clipp Player</p>
          <p>-- Ability to React</p>
        </div>
      </div>
    );
  }
}

ClippPage.propTypes = {
  user: PropTypes.object.isRequired,
  darkMode: PropTypes.bool,
};
